'use-strict';

import angular from 'angular';
import { SurveyRequest, SurveyResponse } from '../../src/app/@shared-types/surveys';
import { ApiService } from '../../src/app/shared/services/api';

export class SurveyAPIService {
  private apiService: ApiService;

  constructor(
    apiService: ApiService,
  ) {
    'ngInject';

    this.apiService = apiService;
  }

  /**
   * Returns the surveys of the last 365 days.
   *
   * @returns {Promise <Array>}
   */
  public getSurveys = (): Promise<SurveyResponse[]> => this
    .apiService.get<SurveyResponse[]>('/api/survey/responses');

  /** When vehicle handover is made and surveys are enabled, send a survey request to the server. */
  public postSurvey = (surveyRequest: SurveyRequest): Promise<void> => this
    .apiService.post<void>('/api/survey', surveyRequest);

  public deleteSurvey = (surveyId: string): Promise<void> => this
    .apiService.delete<void>(`/api/survey/${surveyId}`);
}

export default angular.module('services.surveyApiService', [])
  .service('surveyApiService', SurveyAPIService)
  .name;
